module.exports = __webpack_public_path__ + "static/media/gemelo_interno.e7a918d2.png";